import { RESELLER_LIST, RESELLER_UPDATE } from '../Actions/ResellerMapList.action';
import { GOOGLEMAP_SET_ADVANCEDMARKER_OPEN, GOOGLEMAP_SET_ADVANCEDMARKER_ID, GOOGLEMAP_SET_AUTOCOMPLETE_PLACE } from '../constants';

const DEFAULT_STATE = {
      lat: 57.6538,
      longt: 14.2008,
      myLat:0,
      myLongt:0,
      firstload:true,
      items:[],
      initialItems:[],
      selected:[],
      defaultZoomSize:10,
      allReseller:[],
      open_trailerscount:0,
      boat_trailerscount:0,
      servicecount:0,
      dealerLocatorIcons:{},
      advancedMarkerIsOpen: false,
      advancedMarkerId: null,
      autocompletePlace: null
};

export const resellermaplist = (state = DEFAULT_STATE, action) => {
    const { type, payload } = action;
    switch (type) {     
        case RESELLER_LIST:
            return {    
                ...state,            
                lat:payload.defaultLatitude,            
                longt:payload.defaultLongitude,              
                defaultZoomSize:payload.defaultZoomSize,
                items:payload.items,
                selected:[],
                initialItems:payload.items,
                firstload:true,
                allReseller:payload.allReseller,
                initialAllReseller:payload.allReseller,
                dealerLocatorIcons: payload.dealerLocatorIcons
            };
        case RESELLER_UPDATE:  
            return {
                ...state,
                ...payload,
                firstload:false
            };
        case GOOGLEMAP_SET_ADVANCEDMARKER_OPEN:
            return {
            ...state,
            advancedMarkerIsOpen: payload.value
            };
        case GOOGLEMAP_SET_ADVANCEDMARKER_ID:
            return {
            ...state,
            advancedMarkerId: payload.value
            };
        case GOOGLEMAP_SET_AUTOCOMPLETE_PLACE:
            return {
            ...state,
            autocompletePlace: payload.value
            };
        default:
            return state;
    }
};